import { blogCountFun, blogFun } from '../../../api/blogAPI';
import errorHandle from '../../../utils/errorHandle';

export default async function fetchBlogsData(setBlogData, setLoading, limit = 10, offSet = 0) {
    setLoading(true);
    try {
        const blogs = await blogFun(limit, offSet);
        setBlogData(blogs?.data);
        setLoading(false);
    } catch (error) {
        errorHandle(error);
        setLoading(false);
    }
}

export const blogCount = (setTotalCount, setLoading) => {
    setLoading(true);
    try {
        blogCountFun().then((res) => {
            setTotalCount(res.data.blogCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
